import React, { forwardRef, ReactNode, Ref } from 'react';
import Box from '../Box';
import styles from './shoppableOutfitBase.module.scss';

const aspectRatioToPercentString = (aspectRatio: number) => {
  const ratioAsPercentage = (1.0 / aspectRatio) * 100;

  return `${ratioAsPercentage.toFixed(0)}%`;
};

type ShoppableOutfitBaseProps = {
  aspectRatio?: number;
  children: ReactNode;
};

/**
 * Shared by ShoppableOutfit and ShoppableOutfitPlaceholder, this manages the aspect ratio and
 * background color of the outermost containing box
 */
const ShoppableOutfitBase = forwardRef(
  (
    { aspectRatio = 1.0, children }: ShoppableOutfitBaseProps,
    ref?: Ref<HTMLDivElement>,
  ) => (
    <Box
      ref={ref}
      className={styles['outfit-container']}
      data-testid="shoppable-outfit"
    >
      <Box
        data-testid="outfit-images-container"
        className={styles['outfit-images-container']}
        // Why padding-top? We're using it to control outfit aspect-ratio
        // See also: https://css-tricks.com/aspect-ratio-boxes/
        style={{ paddingTop: aspectRatioToPercentString(aspectRatio) }}
      >
        {children}
      </Box>
    </Box>
  ),
);

export default ShoppableOutfitBase;
